import React, { useContext, useState } from "react";
import { FormProvider, useFormCtx } from "./FormContext";

import * as Const from "./_Const";
import AnimatedRoute from "./AnimatedRoute";

//
function App() {
  // console.log(process.env.REACT_APP_MODE);
  // console.log(process.env.REACT_APP_VERSION);
  // console.log(Const.isProduction());

  return (
    <FormProvider>
      <AnimatedRoute />
    </FormProvider>
  );
}

export default App;
